'use strict';

var GoogleMapsLoader = require('./lib/google-maps');
var TPromise = window.Promise || require('promise');

var map, pin, pinSelected, previousMarker = null;
var autocompleteInput = $('.core-storelocator-formArea-contentInput input')[0];
var gmapsOpts;

var google = [];
var geoloc;
var gmapsStyles = [{featureType:"all",elementType:"geometry.fill",stylers:[{weight:"2.00"}]},{featureType:"all",elementType:"geometry.stroke",stylers:[{color:"#9c9c9c"}]},{featureType:"all",elementType:"labels.text",stylers:[{visibility:"on"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f2f2f2"}]},{featureType:"landscape",elementType:"geometry.fill",stylers:[{color:"#ffffff"}]},{featureType:"landscape.man_made",elementType:"geometry.fill",stylers:[{color:"#ffffff"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:-100},{lightness:45}]},{featureType:"road",elementType:"geometry.fill",stylers:[{color:"#eeeeee"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#7b7b7b"}]},{featureType:"road",elementType:"labels.text.stroke",stylers:[{color:"#ffffff"}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#46bcec"},{visibility:"on"}]},{featureType:"water",elementType:"geometry.fill",stylers:[{color:"#c8d7d4"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#070707"}]},{featureType:"water",elementType:"labels.text.stroke",stylers:[{color:"#ffffff"}]}];
var hasUChangedMapEvent = false;
var isSearch = window.location.search.length > 2; //TODO find more reliable way for this
var markersMap = {};
var layers = {'all': []};
var clusterer;

var opts = $('.core-storelocator').data('options');
gmapsStyles = $('.core-storelocator').data('googlestyle');
$('.core-storelocator').removeAttr('data-googlestyle data-options');

var mapsLoaded = new TPromise(function (res) {
    GoogleMapsLoader.KEY = opts.googleKey;
    GoogleMapsLoader.LIBRARIES = ['places'];
    GoogleMapsLoader.URL = opts.mapsUrl + '/api/js';
    GoogleMapsLoader.VERSION = '3.31';
    GoogleMapsLoader.LANGUAGE = $('html').attr('lang');
    GoogleMapsLoader.REGION = opts.countryCode;

    GoogleMapsLoader.load(function (_google) {
        res(_google);
    });
});

var zoomLevelSwitch = 13;

require('jquery-keyboard-focus');
var util = require('./lib/util');
function setCoordsToFloat(gmapsOpts) {

    //just making sure that if lat and long have values, they're set as float.
    gmapsOpts.center.lat = (gmapsOpts.center.lat) ? parseFloat(gmapsOpts.center.lat) : gmapsOpts.center.lat;
    gmapsOpts.center.lng = (gmapsOpts.center.lng) ? parseFloat(gmapsOpts.center.lng) : gmapsOpts.center.lng;

    return gmapsOpts
}

exports.init = function () {
    util.keyBoardFocus();
    opts = $('.core-storelocator').data('options');
    gmapsOpts = opts.gmapsOptions;
    gmapsOpts = setCoordsToFloat(gmapsOpts);
    gmapsOpts.styles = gmapsStyles;

    if (opts.isGeolocated) {
        geoloc = opts.geolocation;
    }

    var geolocated = geolocate().catch(function () {console.log('location disabled');});

    if (window.location.protocol === 'http:') {
        toHttps();
    }

    var mapsInit = mapsLoaded.then(function (_google) {
        return new TPromise(function(res) {
            google = _google;
            initMap();
            res();
            initGMapsAutocomplete();
        });
    }, rej);

    var tilesLoaded = mapsInit.then(function () {
        return new Promise(function (res) {
            addOnceListener('tilesloaded', res);
        });
    }, rej);

    var clusterInit;
    if (isSearch && !opts.isGeolocated) {
        clusterInit = mapsInit
            .then(initCountry)
            .then(initCluster)
            .catch(rej);
    } else {
        clusterInit = mapsInit
            .then(initCountry)
            .then(initCluster)
            .catch(rej);

        TPromise.all([geolocated, clusterInit])
            .then(initGeolocation)
            .then(markGeolocation)
            .catch(rej);
    }

    TPromise.all([tilesLoaded, clusterInit])
        .then(function () {
            refreshMarkers();
            updateResultNb();
            initUChangedMapEvent();
            $('.core-storelocator-Map').removeClass('pre-init');
        }, rej);

    $('.core-storelocator-contentList')
        .on('click', '.core-storelocator-item', function (e) {
            var $target = $(e.currentTarget),
                storeId = $target.data('storeId');

            selectMarker(storeId, true);
        })
        .on('click auxclick contextmenu', '.core-storelocator-btnGetDirections', function (e) {
            if (!geoloc) { return; }
            e.stopPropagation();

            var dirStr = '/dir/' + geoloc.latitude + ',' + geoloc.longitude + '/';
            e.target.href = e.target.href.replace('/dir//', dirStr);
        })
        .on('click', '.core-storelocator-btnSeemore', seeMore)
        .on('click', '.core-storelocator-btnGoto', function(e) {
            var $item = $(e.target).parents('.core-storelocator-area'),
                coords = $item.data('bounds').split(','),
                bounds = { east: 0, north: 0, south: 0, west: 0};

            $.each(bounds, function (key) { bounds[key] = parseFloat(coords.shift()) });

            map.fitBounds(bounds);
            setZoom(gmapsOpts.zoom);
        });

    $('.core-storelocator')
        .on('click', '.js-core-storelocator-geoloc', onGeolocClick)
        .on('click', '.core-storelocator-btnSearch', applyFilter)
        .on('keydown', '.core-storelocator-btnSearch', adaBtn);


    $('.js-Storelocator-input').on('focusout', function() {
        $('.js-Storelocator-input').attr('aria-expanded', false);
    });

    $('.js-Storelocator-input').on('focusin click keydown', function() {
        window.setTimeout(function() {
            $('.js-Storelocator-input')
                .attr('aria-expanded', $('.pac-container').is(':visible'));
        }, 500);
    });
};

function toHttps() {
    window.location.protocol = 'https:';
}

function onGeolocClick (evt) {
    evt.stopPropagation();
    evt.preventDefault();

    autocompleteInput.value = '';

    geolocate()
        .then(initGeolocation, toHttps)
        .then(markGeolocation)
        .then(refreshList)
        .catch(rej);
}

function refreshSidebar() {
    $('.core-storelocator-items').toggle(map.getZoom() >= gmapsOpts.zoom);
    $('.core-storelocator-areas').toggle(map.getZoom() < gmapsOpts.zoom);
}

function refreshList() {
    var opts = $('.core-storelocator').data('options');
    var bounds = map.getBounds(),
        axisClass = opts.filter === 'all' ? '*' : ('.' + opts.filter),
        count = 1;

    $('.core-storelocator-item').hide()
        .filter(axisClass).each(function (i, e) {
            var $e = $(e),
                marker = markersMap[$(e).data('storeId')];
            if (typeof marker === 'undefined' || bounds.contains(marker.position)!==true) { return; }

            $e.show();
            if (opts.isGeolocated && marker.label) {
                $e.find('.core-storelocator-itemNumber').text(count);
                marker.label.text = count++;
            }
            if (geoloc && !isSearch) {
                $e.find('.core-storelocator-itemDistance')
                    .text(computeDistance(marker.position));
            }

        });
    util.keyBoardFocus();
}

function applyFilter(evt) {
    var opts = $('.core-storelocator').data('options');
    evt.preventDefault();
    var $target = $(evt.currentTarget),
        axis = $target.data('axis');

    opts.filter = axis;

    $('.core-storelocator-btnSearch')
        .removeClass('active')
        .attr('aria-selected', false)
        .attr('tabindex', '-1');

    $target
        .attr('aria-selected', true)
        .addClass('active')
        .attr('tabindex', '0');

    activateLayer(layers[axis]);

    var loadedAjaxMap = loadAjaxMap({isGeolocated: opts.isGeolocated}, true);

    if (!opts.isGeolocated) {
        loadedAjaxMap.then(refreshMarkers);
    }

    updateTitle($target);
}

function adaBtn(evt) {
    if (evt.keyCode === 37) {
        // Left arrow key
        $(evt.target)
            .parent()
            .prev()
            .find('.core-storelocator-btnSearch')
            .focus().click()
    } else if (evt.keyCode === 39) {
        // Right arrow key
        $(evt.target)
            .parent()
            .next()
            .find('.core-storelocator-btnSearch')
            .focus()
            .click();
    }
}

function toggleSeeMore($item) {
    var $moreDetails = $item.find('.core-storelocator-itemSeemoreDetail, .core-storelocator-itemSeemoreDetailCustom');

    $item.toggleClass('core-storelocator-item--full');
    $moreDetails.slideToggle();
}


function seeMore(e) {
    e.stopPropagation();
    var $target = $(e.currentTarget),
        $item = $target.parents('.core-storelocator-item'),
        marker = markersMap[$item.data('storeId')];

    var service = new google.maps.places.PlacesService(map);

    if ($item.is('.initiated')) {
        return toggleSeeMore($item);
    }

    $item.addClass('initiated');

    $('.core-storelocator-itemSeemoreDetail, .core-storelocator-itemSeemoreDetailCustom').removeAttr('tabindex');
    $item.find('.core-storelocator-itemSeemoreDetail, .core-storelocator-itemSeemoreDetailCustom').attr('tabindex',-1).focus();

    service.nearbySearch({
        keyword: $item.find('h2, .core-storelocator-itemAddress').text(),
        location: marker.getPosition(),
        radius: 500,
        type: ['store']
    }, function (result) {
        if (!result[0]) {
            return toggleSeeMore($item);
        }

        service.getDetails({
            placeId: result[0].place_id
        }, function (place) {
            $item.data('details', true);

            if (place.opening_hours) {
                var $openingHours = $('<ul class="openingHours"></ul>')
                    .prependTo($item.find('.core-storelocator-itemSeemoreDetail'));

                for (var i = place.opening_hours.weekday_text.length - 1; i >= 0 ; i--) {
                    $openingHours.prepend('<li>' + place.opening_hours.weekday_text[i] + '</li>');
                }

                $openingHours.show();
                $item.addClass('full-height')
                    .find('.noResult').hide();
            }

            if (place.formatted_phone_number) {
                $item.find('.phoneNumber')
                    .append(place.formatted_phone_number)
                    .show();

                $item.find('.noResult').hide();
            }

            toggleSeeMore($item);
        });
    });
}

function initGeolocation() {
    return loadAjaxMap({
        isGeolocated: 1,
        lat: geoloc.latitude,
        lng: geoloc.longitude
    });
}

function markGeolocation() {
    var opts = $('.core-storelocator').data('options');
    if (!geoloc) { return console.warn('Unknown geolocation'); }
    map.setCenter({
        lat: geoloc.latitude,
        lng: geoloc.longitude
    });
    setZoom(gmapsOpts.zoom);

    var curLocation = new google.maps.Marker({
        position: { lat: geoloc.latitude, lng: geoloc.longitude },
        clickable: false,
        icon: {
            url: opts.location,
            origin: new google.maps.Point(0, 0),
            scaledSize: new google.maps.Size(23, 23)
        },
        map: map
    });

    curLocation.setZIndex(500);
    util.keyBoardFocus();
    refreshSidebar();
}

function rej() {
    console.error(arguments);
}

function initCluster() {
    var opts = $('.core-storelocator').data('options');
    return new TPromise( function(res, rej) {
        if (!window.storelocator_data) {
            window.storelocator_data = [];
            window.storelocator_data.push = function (data) {
                Array.prototype.push.call(window.storelocator_data, data);
                initCluster().then(res, rej);
            }
            return;
        }

        var MarkerClusterGroup = require('MarkerClusterGroup'); // eslint-disable-line no-undef
        
        var data = window.storelocator_data[0];

        clusterer = new MAP.MarkerClusterGroup({ // eslint-disable-line no-undef
            singleMarkerMode: true,
            zoomToBoundsOnClick: false,
            spiderfyOnMaxZoom: false,
            maxClusterRadius: 60,
            disableClusteringAtZoom: zoomLevelSwitch
        });

        clusterer.on('clusterclick', function (event, group, cluster) {
            var baseZoom = map.getZoom();

            while (cluster._childClusters.length === 1 && cluster._zoom < zoomLevelSwitch) {
                cluster = cluster._childClusters[0];
            }
            map.setCenter(cluster._cPosition);

            if (baseZoom === map.getZoom() || !cluster._childClusters.length) {
                map.setZoom(cluster._zoom + 1);
            } else {
                map.setZoom(cluster._zoom);
            }
        });

        var j;

        for (j = 0; j < opts.layers.length; j++) {
            layers[opts.layers[j]] = [];
        }

        for(var d, m, i = 0, l = data.length; i < l; i++) {
            d = data[i];
            m = new google.maps.Marker();
            m.setPosition(new google.maps.LatLng(d[1], d[2]));
            m.setVisible(false);
            m.addListener('click', function() {
                selectMarker(this.__id);
            });

            m.__layerNames = d[3];
            m.__id = d[0];

            markersMap[d[0]] = m;
            for (j = 0; j < opts.layers.length; j++) {
                var layerName = opts.layers[j];
                if (d[3].indexOf(layerName) !== -1) {
                    layers[layerName].push(m);
                }
            }

            layers['all'].push(m);
        }

        clusterer.setMap(map);
        activateLayer(layers['all']);

        res();
    });
}

function activateLayer(layer) {
    clusterer.clearLayers();
    clusterer.addLayers(layer);

    updateResultNb();
}

function geolocate() {
    return new TPromise(function(res, rej) {
        if (!navigator.geolocation) { return rej(); }
        if (geoloc) { return res(); }

        navigator.geolocation.getCurrentPosition(function (result) {
            if (isNaN(result.coords.latitude) || isNaN(result.coords.longitude)) { // IE 11
                return rej();
            }
            geoloc = result.coords;

            $('.js-core-storelocator-noGeoloc').slideUp();

            res();
        }, function () {
            $('.js-core-storelocator-noGeoloc').slideDown();
            return rej();
        });
    });
}

function loadAjaxMap(options) {
    var baseOpts = {
        ajax: 1,
        filter: opts.filter
    }

    var urlOpts = {
        lat: opts.isGeolocated && geoloc.latitude ||
            map && map.getCenter && map.getCenter().lat(),
        lng: opts.isGeolocated && geoloc.longitude ||
            map && map.getCenter && map.getCenter().lng()
    }

    var ajaxLoaded = $.get(window.location.pathname, $.extend(baseOpts, urlOpts, options)).promise();

    return ajaxLoaded.then(function (resp) {
        if (!map) { return; }
        var $resp = $(resp);

        opts = $resp.filter('.core-storelocator').data('options');
        gmapsOpts = opts.gmapsOptions;
        $resp.find('.core-storelocator-items')
            .replaceAll('.core-storelocator-items');
        refreshSidebar();
        refreshList();
    }, rej);
}

function initCountry() {
    var opts = $('.core-storelocator').data('options');
    map.fitBounds(opts.viewport);
}

function addOnceListener(eventName, callback) {
    var onceListener = map.addListener(eventName, function () {
        google.maps.event.removeListener(onceListener);
        callback();
    });
}

var currentZoom;
function setZoom(zoom) {
    currentZoom = zoom;
    map.setZoom(zoom);
}

function initUChangedMapEvent() {
    if (hasUChangedMapEvent) { return; }

    hasUChangedMapEvent = true;

    map.addListener('dragend', onUChangedMap.bind(null, 1000));
    map.addListener('idle', updateResultNb);

    currentZoom = map.getZoom();
    map.addListener('zoom_changed', onZoomChange);
    util.keyBoardFocus();
}

function onZoomChange() {
    refreshSidebar();

    // Workaround false zoom_changed evts triggered from fitBounds
    if (currentZoom !== map.getZoom()) {
        if (currentZoom !== -1) {
            onUChangedMap();
        }

        currentZoom = map.getZoom();
    }
}

function updateResultNb() {
    var key;
    var bounds = map.getBounds(),
        counts = {},
        layer = layers['all'];

    if (!bounds) { return; }
    if (!layer.length) { return; }

    for (key in layers) {
        counts[key] = 0;
    }

    for (var i = 0; i < layer.length; i++) {
        var m = layer[i];

        if (bounds.contains(m.position)===true) {
            for (key in layers) {
                if (m.__layerNames.indexOf(key) !== -1) {
                    counts[key]++;
                }
            }
            counts['all']++;
        }
    }
    var opts = $('.core-storelocator').data('options');
    $('#core-storelocator-nbResult').text(counts[opts.filter]);

    $('.core-storelocator-btnSearch').each(function (i, e) {
        var $e = $(e),
            count = counts[$e.data('axis')];
        $e
            .toggleClass('disabled', !count)
            .find('.core-storelocator-textFilter')
            .text(function (i, text) { // eslint-disable-line no-unused-vars
                return text.replace(/\d+/, count);
            });
        util.keyBoardFocus();
    });
}

var boundsTimeout;
function onUChangedMap(timeout) {
    window.clearTimeout(boundsTimeout);

    boundsTimeout = window.setTimeout(function () {
        loadAjaxMap().then(refreshMarkers, rej);
    }, timeout || 500);
}

function initMap() {
    map = new google.maps.Map($('.core-storelocator-Map')[0], gmapsOpts);

    pin = {
        url: opts.pin,
        anchor: new google.maps.Point(30, 54)
    };
    pinSelected = $.extend({}, pin, {url: opts.pinSelected});
    util.keyBoardFocus();
}

var numberedMarkers = [];
function refreshMarkers() {
    var $items = $('.core-storelocator-item'),
        bounds = map.getBounds();

    $items.each(function (i, e) {
        var $e = $(e),
            marker = markersMap[$e.data('store-id')];
        if (marker === undefined) { return;}
        var  onMap = bounds.contains(marker.getPosition());

        if (i == $items.length) {
            marker.setIcon(pinSelected);
        }

        marker.setIcon(pin);
        marker.setLabel('');
        marker.setVisible(true);
        numberedMarkers.push(marker);

        if (onMap) {
            marker.setLabel({text: '' + (i + 1)});
        } else {
            $e.hide();
        }
    });

    updateTitle(false);
    util.keyBoardFocus();
}

function initGMapsAutocomplete() {
    var autocomplete = new google.maps.places.Autocomplete(autocompleteInput);
    autocomplete.addListener('place_changed', onPlaceChange);

    window.autocomplete = autocomplete;

    google.maps.event.addDomListener(autocompleteInput, 'keydown', function(evt) {
        if (evt.keyCode === 13) {
            evt.preventDefault();
        }
    });
}

function onPlaceChange(point) {
    var isGMaps = !point,
        name = encodeURIComponent(isGMaps ? this.getPlace().formatted_address : autocompleteInput.value),
        lat = isGMaps ? this.getPlace().geometry.location.lat() : point.lat,
        lng = isGMaps ? this.getPlace().geometry.location.lng() : point.lng;

    isSearch = true;

    $('html, body').animate({ scrollTop: $('.core-storelocator').offset().top}, 1000);
    addOnceListener('idle', setZoom.bind(null, 12));
    map.setCenter({ lat: lat, lng: lng });

    return loadAjaxMap({
        name: name,
        lat: lat,
        lng: lng
    }).then(refreshMarkers)
        .then(updateResultNb);
}

function selectMarker(storeId, listOrigin) {
    var marker = markersMap[storeId],
        $html = $('html'),
        $items = $('.core-storelocator-items'),
        $allItems = $('.core-storelocator-item'),
        $item = $allItems.filter('[data-store-id=' + storeId + ']');

    $allItems.removeClass('core-storelocator-item--active');
    $item.addClass('core-storelocator-item--active');

    if ($html.width() > 800) { // Desktop
        $items.animate({
            scrollTop: $items.prop('scrollTop') + $item.position().top
        }, 1000);
    } else { // Mobile
        if (listOrigin) {
            $('html, body').animate({ scrollTop: $('.core-storelocator').offset().top}, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $item.offset().top - $(window).height() + $item.height()
            }, 1000);
        }
    }
    map.setCenter(marker.getPosition());
    addOnceListener('bounds_changed', function () {
        addOnceListener('idle', function () {
            refreshList();
            setZoom(15);
        });
    });

    if (previousMarker) {
        previousMarker.label || previousMarker.setLabel('');
        if (typeof previousMarker.label !== 'undefined'  && typeof previousMarker.label !== 'string') {
            previousMarker.label.color = 'black';
        }
        previousMarker.setIcon(pin);
        previousMarker.setZIndex(1);
    }

    marker.label || marker.setLabel('');
    if (typeof marker.label !== 'undefined' && typeof marker.label !== 'string') {
        marker.label.color = 'white';
    }
    marker.setIcon(pinSelected);
    marker.setZIndex(1000);

    previousMarker = marker;
}

function updateTitle(axis) {
    var opts = $('.core-storelocator').data('options');
    var title = opts.resourceText.STORE_SEARCH_RESULTS;

    if (autocompleteInput.value.length > 0) {
        title += " " + autocompleteInput.value;
    }

    if (axis !== false && axis.data('axis') != 'all') {
        var labelAxis = axis.children('span').html().split('(')[0];
        title += " (" + opts.resourceText.STORE_SEARCH_FILTERED + " " + labelAxis + ") ";
    }

    title += opts.resourceText.GLOBAL_STORENAME;

    document.title = title;
}

function computeDistance(point) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(point.lat() - geoloc.latitude);  // deg2rad below
    var dlng = deg2rad(point.lng() - geoloc.longitude);
    var a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(deg2rad(geoloc.latitude)) * Math.cos(deg2rad(point.lat())) *
        Math.sin(dlng/2) * Math.sin(dlng/2)
    ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    var d = R * c; // Distance in km
    return d > 1 ? (d.toFixed(2) + 'km') : (d.toFixed(3) * 1000 + 'm');
}

function deg2rad(deg) {
    return deg * (Math.PI/180)
}
